module.exports = "/assets/data/eac054d3cfad8d9ad943147dd39a7988-HA2.data.json";